import { AxiosError, AxiosResponse } from 'axios';
import { IMap } from './Interfaces';

export type SuccessfulResponse<Type, Status = number> = {
  success: true;
  response: AxiosResponse<Type>;
  status: Status;
};
export type ErrorResponse<Type, Status = number> = { success: false; response: AxiosError<Type>; status: Status };
export type ValidationErrorResponseData = {
  message: string;
  errors: IMap<string[], string>;
  rules: IMap<IMap<string[], string>, string>;
};
export type ValidationErrorResponse = ErrorResponse<
  ValidationErrorResponseData,
  ReservedHttpResponseCodes.ValidationError
>;
export type RenderableErrorResponse<P = Record<string, any>> = AxiosError<{
  title: string;
  description: string;
  error_code: string;
  payload?: P;
}>;
export type Response<Type, Status = number> = SuccessfulResponse<Type, Status> | ErrorResponse<Type, Status>;

export type DataWrappedResponse<Type, Status = number> = Response<DataWrapper<Type>, Status>;

export type DataWrapper<Type> = { data: Type };

export enum ReservedHttpResponseCodes {
  PaymentConfirmationRequired = 402,
  ValidationError = 422,
  ErrorResponseModal = 412,
  ErrorResponseAlertWindow = 417,
}

export type FeedbackLabelTypes = 'Success' | 'Error' | 'Info' | 'Warning' | 'Notice';
